import serviceListrightArrow from 'aurora-images/serviceListrightArrow.svg';
const locale = localStorage.getItem('lang');
const styles = () => ({
  topheader: {
    backgroundColor: '#fff',
    fontSize: '18px',
    padding: '18px 16px',
    borderBottom: '1px solid #EBEEF3',
  },
  LinkMain: {
    backgroundColor: '#fff',
    margin: '18px 16px',
    borderRadius: '8px',
  },
  sidebarListItem: {
    color: '#342D3D',
    padding: '16px 0px',
    margin: '0px 16px',
    borderBottom: '1px solid #EBEEF3',
    '&:last-child': {
      borderBottom: 'none',
    },
    paddingLeft: '19px',
    display: 'flex',
    position: 'relative',
    '& h3': {
      fontSize: '16px',
      fontWeight: '500',
      paddingLeft: '14px',
    },
    '&:hover': {
      background: '#EFFBFC',
      color: '#1C999B',
      textDecoration: 'none',
    },
    '&:after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      right: '15px',
      transform: locale === 'en' ? 'translateY(-50%)  rotate(0deg)' : 'translateY(-50%) rotate(180deg)',
      backgroundImage: `url(${serviceListrightArrow})`,
      backgroundRepeat: 'no-repeat',
      height: '16px',
      width: '8px',
    },
  },
});

export default styles;
